document.addEventListener('DOMContentLoaded', function () {
    var wrap = document.querySelector('.hero__video');
    if (!wrap) return;

    var video = wrap.querySelector('.hero__video-el');
    var play = wrap.querySelector('.hero__play');
    if (!video || !play) return;

    play.addEventListener('click', function () {
      video.play();
    });

    video.addEventListener('click', function () {
      if (video.paused) {
        video.play();
      } else {
        video.pause();
      }
    });

    video.addEventListener('play', function () {
      wrap.classList.add('is-playing');
    });

    video.addEventListener('pause', function () {
      wrap.classList.remove('is-playing');
    });

    video.addEventListener('ended', function () {
      wrap.classList.remove('is-playing');
      video.currentTime = 0;
    });
  });
